exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n#tsparticles {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  background-image: url(\"\");\n  background-repeat: no-repeat;\n  background-size: cover;\n  background-position: 50% 50%;\n}\n", ""]);

// exports
